  import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useDispatch } from "react-redux";
import { setOtherUsers, setAllUsers, addMoreUsers, setPagination } from '../redux/userSlice';
import { BASE_URL } from '../config';


const useGetOtherUsers = () => {
    const dispatch = useDispatch();
    //   const [hasMore, setHasMore] = useState(true);
 

    useEffect(() => {
        let isMounted = true;
        let intervalId = null;

        const fetchOtherUsers = async (page) => {
            const abortController = new AbortController();
            
            try {
                const res = await axios.get(`${BASE_URL}/api/v1/user?page=${page}&limit=10`, {
                    signal: abortController.signal,
                    withCredentials: true,
                    headers: {'Content-Type': 'application/json'}
                });

                if (!isMounted) return;

                const responseData = res.data?.users || [];
                const validUsers = Array.isArray(responseData) ? responseData : [];
                //  const validUsers = responseData.filter(user => user?._id);

                const usersWithDefaults = validUsers
                    .filter(user => user?._id && user.isRole !== 1)
                    .map(user => ({
                        ...user,
                        lastMessageTime: user.lastMessageTime || new Date(0).toISOString(),
                        lastMessageContent: user.lastMessageContent || ''
                    }));

                    
                //        dispatch(setAllUsers(validUsers));
                // dispatch(setOtherUsers(validUsers));
                     // Update Redux store based on page number
                if(page === 1) {
            dispatch(setOtherUsers(validUsers));
            dispatch(setAllUsers(validUsers));
        } else {
            dispatch(addMoreUsers(validUsers));
        }
    

        // Update pagination state
        // setHasMore(res.data?.pagination?.hasNextPage || false);
            dispatch(setPagination({
        hasMore: res.data?.pagination?.hasNextPage
      }));
            } catch (error) {
                if (!abortController.signal.aborted && isMounted) {
                    console.log("Error fetching users:", error);
                        dispatch(setOtherUsers([]));
                dispatch(setAllUsers([]));
                }
                
            }
        };

        // Initial fetchs
        fetchOtherUsers(1);

        // Start safe polling
        const startPolling = () => {
            intervalId = setInterval(() => {
                    
                if (isMounted) fetchOtherUsers(1);
               
            }, 10000);
        };
        startPolling();

      

        return () => {
            isMounted = false;
            clearInterval(intervalId);
        };
    }, [dispatch]);
    
    return null;
};

export default useGetOtherUsers;
